import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ReservationChannels } from '../../../models/List.Restaurant';
import { RestaurantService } from '../../../services/Restaurant.service';
import { ReservationChannelsComponent } from './components/reservation-channels/reservation-channels.component';
import { RestaurantConfigComponent } from './components/restaurant-config/restaurant-config.component';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html'
})
export class ReservationComponent implements OnInit {

  dataLoading = false;
  canEdit!: boolean;
  restaurantId: any;

  reservationChannels: ReservationChannels[] = []

  selectedReservationChannels: ReservationChannels[] = []

  placeOrderTime: any;
  canEditplaceOrderTime!: boolean;
  constructor(public dialog: MatDialog, private route: ActivatedRoute,
    private service: RestaurantService) {
    this.route.params.subscribe(params => {
      this.restaurantId = params['id'];
    });
   }

  ngOnInit(): void {
    this.GetReservationChannels();
    this.getRestaurantConfig()
  }


  GetReservationChannels() {
    this.dataLoading = true;
    this.service.GetReservationChannels(this.restaurantId).subscribe((data: any) => {
      this.reservationChannels = data.allReservationChannels
      this.selectedReservationChannels = data.selectedReservationChannels;
      this.canEdit = data.canEdit
      this.dataLoading = false;
    })
  }

  editReservationChannels() {
    const dialogRef = this.dialog.open(ReservationChannelsComponent, {
      width: '50rem',
      data: { restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.GetReservationChannels()
      }
    });
  }

  getRestaurantConfig() {
    this.service.getRestaurantConfig(this.restaurantId).subscribe((data: any) => {
      this.placeOrderTime = data.placeOrderTime
      this.canEditplaceOrderTime = data.canEdit
    })
  }
  editRestaurantConfig() {
    const dialogRef = this.dialog.open(RestaurantConfigComponent, {
      width: '50rem',
      data: { placeOrderTime: this.placeOrderTime,  restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getRestaurantConfig()
      }
    });
  }
}
